<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.36 15.36">
  <g>
    <polygon class="filled" points="8.344 3.214 7.637 3.921 10.895 7.18 2.657 7.18 2.657 8.18 10.895 8.18 7.637 11.439 8.344 12.146 12.81 7.68 8.344 3.214" fill="#70a3e0"/>
    <rect width="15.36" height="15.36" fill="none"/>
  </g>
</svg>
